import { FC } from "react";
import UserAvatar from "../avatar";
import { TPartnerInfo } from "../../types";
import defultProfilePic from "../../assets/images/single_bill.svg";
import {
  getDestChequeIcon,
  getDestPfAgree,
  getMaskedMobileNumber,
  getSrcChequeIcon,
  getSrcPfAgree,
  hasSrcDestPfAgree,
} from "../../helpers/get-currency-number";
import Tooltip from "@mui/material/Tooltip/Tooltip";

const UserDetails: FC<TPartnerInfo> = ({
  profilePic,
  name,
  partnerMobile,
  partnerId,
  Address,
  trader = false,
  partnetAddress = "",
  partyName,
  fromLoansParty = false,
  distanceFrom,
  distance,
  color,
  shortName,
  partnerType,
  productStatus = false,
  chequeStatus,
  fullPartnerAddress = "",
  nameLabel = false,
  tradeType = "",
  srcCheque = "",
  destCheque = "",
  srcPfAgree = "",
  destPfAgree = "",
  isSrcIcons = false,
  isDestIcons = false,
  fromLoanNewParty = false,
  fromLoanTabBen = false,
  isCashId = false,
  cashId,
  isShortNameLeft = false,
  userChequeStatus = "",
}) => {
  return (
    <div className="flex items-center gap-2.5">
      <div>
        {profilePic ? (
          <img
            src={profilePic || defultProfilePic}
            alt="user_profile_pic"
            className="w-8 h-8 br-100"
            style={{ maxWidth: "initial" }}
          />
        ) : (
          <UserAvatar name={name} />
        )}
      </div>

      <div className="flex flex-col">
        <div className="flex items-start gap-1">
          {nameLabel && (
            <span className="text-sm shrink-0">
              {tradeType === "SOURCE" ? "From:" : "To:"}
            </span>
          )}

          <div className="flex flex-col">
            <span
              className={`text-sm ${
                color === "white" ? "text-white" : "color-primary-text"
              }`}
            >
              {name}
            </span>

            {shortName && (
              <p
                className={`fs-12 ${fromLoanTabBen ? "" : "color-sub-text"} ${
                  isShortNameLeft ? "text-left" : ""
                }`}
              >
                {shortName}
              </p>
            )}

            {isCashId && (
              <p className="fs-12 color-sub-text">
                Cash ID - <span className="fs-12 color-blue">{cashId}</span>
              </p>
            )}
          </div>

          {fromLoansParty && fromLoanNewParty && (
            <div className="ml-2 shrink-0">
              <span className="text-sm color-primary bg-light-primary px-2 py-1 br-10">
                New
              </span>
            </div>
          )}
        </div>

        <span
          className={`text-xs ${
            color === "white" ? "text-white" : "color-sub-text"
          }`}
        >
          {fromLoansParty || partnerType ? `${partnerType} -` : ""}
          <span
            className={`${color === "white" ? "color-yellow" : "color-blue"}`}
          >
            {partnerId !== "" ? ` ${partnerId}` : ``}
          </span>
          {partnerMobile !== "" && !distanceFrom
            ? `  ${partnerId !== "" ? ` | ` : ``} ${getMaskedMobileNumber(
                partnerMobile
              )}` || ""
            : distance
            ? ` | Distance ${distance} km`
            : ""}
        </span>

        {partnetAddress && (
          <div className="relative group w-fit">
            <p
              className={`text-xs ${
                color === "white" ? "text-white" : "color-sub-text"
              } max-w-[180px] cursor-default`}
            >
              {partnetAddress}
            </p>

            {fullPartnerAddress && (
              <div className="absolute z-10 hidden group-hover:block bg-gray fs-12 rounded px-3 py-2 left-1/2 bottom-full mb-3 transform -translate-x-1/2 whitespace-pre-wrap w-max max-w-xs shadow-md border border-gray">
                <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-3 h-3 bg-gray rotate-45 border-l border-b border-gray shadow-sm"></div>
                {fullPartnerAddress}
              </div>
            )}
          </div>
        )}

        <p
          className={`text-xs ${
            color === "white" ? "text-white" : "color-sub-text"
          }`}
        >
          {partyName}
        </p>

        {productStatus && <p className="fs-12 color-red">Approval Pending</p>}
        {}
        {isSrcIcons && (
          <div
            className={`flex  ${
              hasSrcDestPfAgree(srcPfAgree) ? "gap-2" : ""
            } mt-1`}
          >
            <div className="relative group">
              <span>{getSrcPfAgree(srcPfAgree)}</span>

              <div className="absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 hidden group-hover:block z-10">
                <div className="bg-white text-black fs-14 px-2 py-1 rounded shadow-md whitespace-nowrap relative">
                  {srcPfAgree === "ACTIVE"
                    ? "SIGNED"
                    : srcPfAgree === "INVITED"
                    ? "NOT SIGNED"
                    : ""}

                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-[-1px]">
                    <div
                      className="w-0 h-0 border-l-[6px] border-r-[6px] border-t-[8px] 
                      border-l-transparent border-r-transparent border-t-white"
                    ></div>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative group pt-[2px]">
              <span>{getSrcChequeIcon(srcCheque)}</span>

              <div className="absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 hidden group-hover:block z-10">
                <div className="bg-white text-black fs-14 px-2 py-1 rounded shadow-md whitespace-nowrap relative">
                  {srcCheque === "VALID"
                    ? "CHEQUE STATUS ACTIVE"
                    : srcCheque === "EXPIRED"
                    ? "CHEQUE STATUS EXPIRED"
                    : ""}
                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-[-1px]">
                    <div
                      className="w-0 h-0 border-l-[6px] border-r-[6px] border-t-[8px] 
                      border-l-transparent border-r-transparent border-t-white"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {isDestIcons && (
          <div
            className={`flex ${
              hasSrcDestPfAgree(destPfAgree) ? "gap-2" : ""
            } mt-1`}
          >
            <div className="relative group">
              <span>{getDestPfAgree(destPfAgree)}</span>

              <div className="absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 hidden group-hover:block z-10">
                <div className="bg-white text-black fs-14 px-2 py-1 rounded shadow-md whitespace-nowrap relative">
                  {destPfAgree === "ACTIVE"
                    ? "SIGNED"
                    : destPfAgree === "INVITED"
                    ? "NOT SIGNED"
                    : ""}

                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-[-1px]">
                    <div
                      className="w-0 h-0 border-l-[6px] border-r-[6px] border-t-[8px] 
                      border-l-transparent border-r-transparent border-t-white"
                    ></div>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative group pt-[2px]">
              <span>{getDestChequeIcon(destCheque)}</span>

              <div className="absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 hidden group-hover:block z-10">
                <div className="bg-white text-black fs-14 px-2 py-1 rounded shadow-md whitespace-nowrap relative">
                  {destCheque === "VALID"
                    ? "CHEQUE STATUS ACTIVE"
                    : destCheque === "EXPIRED"
                    ? "CHEQUE STATUS EXPIRED"
                    : ""}
                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-[-1px]">
                    <div
                      className="w-0 h-0 border-l-[6px] border-r-[6px] border-t-[8px] 
                      border-l-transparent border-r-transparent border-t-white"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {userChequeStatus && (
          <div className="relative group pt-[2px]">
            {/* Cheque Status Tool Tip */}
            <Tooltip
              title={
                <span className="fs-12">
                  {userChequeStatus === "VALID"
                    ? "CHEQUE STATUS ACTIVE"
                    : userChequeStatus === "EXPIRED"
                    ? "CHEQUE STATUS EXPIRED"
                    : ""}
                </span>
              }
              placement="left"
              arrow
            >
              <span>{getDestChequeIcon(userChequeStatus)}</span>
            </Tooltip>
          </div>
        )}
      </div>
    </div>
  );
};
export default UserDetails;
